/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if(window.location.href.includes('product')) {

        
        document.addEventListener("DOMContentLoaded", function () {
          var productCartButton = document.querySelector('.product-form__add-button');
          /*
          var productCartForm = document.querySelector('.product-form');
          var productCartButton = document.querySelector('.product-form__add-button');
          productCartButton.dataset.from = "from_top";
          window.addEventListener('scroll', function() {
              var top = window.scrollY;
              var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height') + 30);
              var divBottom = document.querySelector('.product-block-list__item:nth-of-type(3)').offsetTop - headerHeight;
              if (divBottom < top) {
                  productCartForm.classList.add('sticky_cart_active');
                  if (typeof window.orientation !== 'undefined') { productCartButton.dataset.from = "from_sticky"; }
              } else {
                  productCartForm.classList.remove('sticky_cart_active');
                  if (typeof window.orientation !== 'undefined') { productCartButton.dataset.from = "from_top"; }
              }
              var headerHeight = document.documentElement.style.getPropertyValue('--header-height');

          });
          */

        // EVENTO GA tracking "Add to cart" da Sticky o da pulsante normale
        productCartButton.addEventListener("click", function () {
          gtag("event", "CustomClick_AddToCart", { click_position: this.dataset.from, });
          ga('send', 'event', 'CustomClick_AddToCart', 'click_position', this.dataset.from);
        });

      
      
        /*
        const miniCart = document.querySelector('[data-action="toggle-mini-cart"]');
        // That is the function called when there is a mutation event
        var callback = function(mutationsList) {
            for(var mutation of mutationsList) {
            if (mutation.type == 'attributes') {
                if(mutation.attributeName === 'aria-expanded') {
                    const isProductFormSticky = productCartForm.classList.contains('sticky_cart_active');
                    if(mutation.target.getAttribute('aria-expanded') === 'true' && isProductFormSticky) {
                        productCartForm.classList.add('cart-open');
                    }
                    else if(mutation.target.getAttribute('aria-expanded') === 'false' && isProductFormSticky) {
                        productCartForm.classList.remove('cart-open');
                    }
                }
            }
            }
        };
        // var observer = new MutationObserver(callback);
        // observer.observe(miniCart, { attributes: true });
        */
    });
}




/* codice per scrivere paramento PR (prodotto) su pagina contatti in campo nascosto form */
if(window.location.href.includes('contatti')) {
    //document.addEventListener("DOMContentLoaded", function () {
        var contactFormProvenienza = document.querySelector('.contactFormProvenienza');
        if (contactFormProvenienza !== null) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const nomeProdotto = urlParams.get('pr');
            contactFormProvenienza.value = nomeProdotto;
        }
    //});
}




/* codice per svuotare i cookie e riallineare il carrello */
  if(window.location.href.includes('cart?cookie=clear')) {
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    //window.location.replace("/discount/BFSALUGEA?redirect=/collections/prodotti");
    window.location.replace("/collections/prodotti?fix="+btoa('cart_reset'));
  }

/* codice per svuotare i cookie e ricreare il carrello */
 if(window.location.href.includes('cart?cookie=recreate')) {
    document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    let address = window.location.search 
    parameterList = new URLSearchParams(address);
    dataCarrello = parameterList.get("b");

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: atob(dataCarrello)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });

    //window.location.replace("/discount/12ANNI?redirect=/cart");
    window.location.replace("/cart?fix="+btoa('cart_reset'));
  }
  



/* codice per controllare parametro FIX= e mandare evento google */
if (window.location.href.indexOf('?fix=') > 0) {
  function check_ga() {
    if (typeof gtag === 'function') {
      const urlParams = new URLSearchParams(window.location.search);
      const var1 = atob(urlParams.get('fix'));
         console.log('evento debug: '+var1); 
           gtag("event", "bugfix", { "event_category": var1,  "event_label": var1  });
    } else {
      setTimeout(check_ga,500);
    }
  }
  check_ga();    
}




/* codice per nascondere ancore video non url */
  if(window.location.href.includes('pages/video#')) {
    document.querySelectorAll('.galleryVideo').forEach(function(el) {
       el.style.display = 'none';
    });
    document.querySelectorAll(location.hash).forEach(function(el) {
       el.style.display = 'block';
    });
  }


/* apertura form da CLASSE klaviyoFormBtn  
if (document.querySelector('.klaviyoFormBtn') != null) {
    document.querySelector('.klaviyoFormBtn').addEventListener('click', function (){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', this.dataset.klaviyoform]);
      });
}*/

if (document.querySelector('.klaviyoFormBtn') != null) {
  console.log('klaviyoFormBtn');
   const cbox = document.querySelectorAll(".klaviyoFormBtn");
   for (let i = 0; i < cbox.length; i++) {
       cbox[i].addEventListener("click", function() {
         console.log(cbox[i]);
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', this.dataset.klaviyoform]);
       });
   }
}



if (document.querySelector('.klaviyoTriggerPromoImmunogea') != null) {
   const cbox = document.querySelectorAll(".klaviyoTriggerPromoImmunogea");
   for (let i = 0; i < cbox.length; i++) {
       cbox[i].addEventListener("click", function() {
         console.log(cbox[i]);
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'USvXjj']);
       });
   }
}




function openPopUpFromBullet(){
  return document.getElementById('bannerPromoCustom').click();
}

function scrollToElement( idElement ) {
        const element = document.getElementById(idElement);
        let position = element.getBoundingClientRect();
        window.scrollTo( { top: position.top + window.scrollY - 180, left: 0, behavior: 'smooth'} );
        //element.scrollIntoView( { behavior: 'smooth'} );
      }





  


document.addEventListener('DOMContentLoaded', function () {
  // Esegui solo su /collections/prodotti (adatta se serve)
  if (!location.pathname.startsWith('/collections/prodotti')) return;

  // Evita log duplicati nella stessa sessione
  if (sessionStorage.getItem('bfplus_seen')) return;

  // Helper cookie
  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  
  // 1) tenta via referrer (se inviato)
  let triggered = false;
  if (document.referrer) {
    try {
      const ref = new URL(document.referrer);
      if (ref.origin === location.origin && ref.pathname.startsWith('/discount/'+code)) {
        console.log('sconto bf plus');
        sessionStorage.setItem('bfplus_seen', '1');
        triggered = true;
        fetch("/checkout?discount=CLEAR")
        .then(() => {
          console.log("Sconti precedenti rimossi, applico:", code);
           fetch("/checkout?discount=CLEAR")
            .then(() => {
              console.log("applicato:", code);
              
            })
        })
      }
    } catch (e) { /* ignore URL parse errors */ }
  }

  // 2) fallback: cookie impostato da Shopify
  if (!triggered) {
    const code = getCookie('discount_code');
    if (code && code.toUpperCase() === 'BFPLUS') {
      console.log('sconto bf plus');
      sessionStorage.setItem('bfplus_seen', '1');
      fetch("/checkout?discount=CLEAR")
        .then(() => {
          console.log("Sconti precedenti rimossi, applico:", code);
           fetch("/checkout?discount="+code)
            .then(() => {
              console.log("applicato:", code);
              
            })
        })
    }
  }
});






document.addEventListener("DOMContentLoaded", function () {

    if(window.location.href.includes('/products/')) {
    var aContattiProvenienza = document.querySelector('a[href="https://salugea.com/pages/contatti?pr=0"]');
    if (aContattiProvenienza) {
      aContattiProvenienza.setAttribute('href', 'https://salugea.com/pages/contatti?pr='+window.location.href)
    }    
  }

  // Alla fine del DOM    link-test-benessere
//const MBultimoLi = document.querySelector('.nav-bar__linklist > li:last-child');
const MBultimoLink = document.querySelector('.nav-bar__linklist > li:last-child').querySelector('a');

const mobileMenuRoot = document.querySelector('.mobile-menu__nav:not(.is_nested)');
const mobileLinks = mobileMenuRoot.querySelectorAll(':scope > li > a.mobile-menu__nav-link');
const MBultimoMobileLink = mobileLinks[mobileLinks.length - 1];

MBultimoLink.addEventListener('click', function (e) {
    e.preventDefault();
    apriTestBenessere();
});
MBultimoMobileLink.addEventListener('click', function (e) {
    e.preventDefault();
    apriTestBenessere();
});


    const links = document.querySelectorAll(".link-test-benessere");

    links.forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            apriTestBenessere();
        });
    });
});

function apriTestBenessere() {
    const isDesktop = rilevaDesktop();
    if (isDesktop) {
        // Desktop → apri pagina
        window.location.href = "https://salugea.com/pages/test-integratori";
    } else {
        // Mobile → popup
        //ApriPopuo('1124');
        window.location.href = "https://salugea.com/pages/test-integratori";
    }
}

/* ============================
   Funzione detection avanzata
   ============================ */
function rilevaDesktop() {
    const width = window.innerWidth;

    // 1. Se ha puntatore fine + no touch → quasi sicuramente desktop
    const pointerFine = window.matchMedia("(pointer: fine)").matches;
    const noTouch = navigator.maxTouchPoints === 0;

    // 2. Schermo grande
    const largeScreen = width >= 1024;

    // Logica combinata
    if ((pointerFine && noTouch) || (largeScreen && noTouch)) {
        return true; // desktop
    }

    // Altrimenti è mobile/tablet
    return false;
}






  function applicaCoupon(couponCode, viewToast) {
    if (!couponCode) return;

    var encodedCoupon = encodeURIComponent(couponCode);

    fetch('/discount/' + encodedCoupon, {
      method: 'GET',
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Errore applicazione coupon');
        }

        if(viewToast){ showCouponToast('Codice sconto "' + couponCode + '" applicato al carrello'); }
      })
      .catch(function () {
        if(viewToast){showCouponToast('Non è stato possibile applicare il codice sconto', true); }
      });
  }

  function showCouponToast(message, isError) {
    var existingToast = document.querySelector('.coupon-toast');

    if (existingToast) {
      existingToast.remove();
    }

    var toast = document.createElement('div');
    toast.className = 'coupon-toast' + (isError ? ' coupon-toast--error' : '');
    toast.textContent = message;

    document.body.appendChild(toast);

    setTimeout(function () {
      toast.classList.add('is-visible');
    }, 50);

    setTimeout(function () {
      toast.classList.remove('is-visible');

      setTimeout(function () {
        toast.remove();
      }, 300);
    }, 3500);
  }
